export const sourceLabels = {
  nav_send: 'NAV küldés',
  nav_sync: 'NAV szinkron',
  edi_order_send: 'EDI küldés',
  edi_order_receive: 'EDI fogadás',
  edi_desadv_send: 'EDI szállítólevél küldés',
};

export const sourceOptions = [
  { value: 'nav_send', label: 'NAV küldés' },
  { value: 'nav_sync', label: 'NAV szinkron' },
  { value: 'edi_order_send', label: 'EDI küldés' },
  { value: 'edi_order_receive', label: 'EDI fogadás' },
  { value: 'edi_desadv_send', label: 'EDI szállítólevél küldés' },
];

export const severityLabels = {
  error: 'Hiba',
  warning: 'Figyelmeztetés',
};

export const severityTagTypes = {
  error: 'danger',
  warning: 'warning',
};

export const severityOptions = [
  { value: 'error', label: 'Hiba' },
  { value: 'warning', label: 'Figyelmeztetés' },
];

export const entityLabels = {
  'App\\Invoice': 'Számla',
  'App\\RepresentativeSale': 'Képviselői eladás',
  'App\\SupplierOrder': 'Beszállítói megrendelés',
  'App\\CustomerOrder': 'Vevői rendelés',
  'App\\EdiInputXml': 'EDI bemeneti XML',
  'App\\EdiReceivedOrder': 'Fogadott EDI rendelés',
  'App\\EdiDesadvShipment': 'DESADV fuvar',
};

// Errorable types backed by an EDI input XML — these expose the "View XML"
// action. Intentionally have no entityRoutes entry, so they show as plain
// text (no link) in the table.
export const ediErrorableTypes = ['App\\EdiInputXml', 'App\\EdiReceivedOrder'];

export function sourceLabel(source) {
  return sourceLabels[source] || source || '—';
}

export function severityLabel(severity) {
  return severityLabels[severity] || severity || '—';
}

export function severityTagType(severity) {
  return severityTagTypes[severity] || 'info';
}

export function entityLabel(type) {
  return entityLabels[type] || type;
}

// Errorable types that have a dedicated detail subpage in the app. Each entry
// builds the route path for a given id and names the permission needed to view it.
export const entityRoutes = {
  'App\\Invoice': {
    path: id => `/sales/invoices/update/${id}`,
    permission: 'invoice.update',
  },
  'App\\SupplierOrder': {
    path: id => `/processes/supplier-orders/view/${id}`,
    permission: 'supplierorder.view',
  },
};

export function entityRoute(type, id) {
  const entry = entityRoutes[type];
  return entry ? entry.path(id) : null;
}

export function entityPermission(type) {
  const entry = entityRoutes[type];
  return entry ? entry.permission : null;
}
